<section style="height: auto;" translate="no">
    <nav>
        <ol class="divbusca">
            <table>
                <tbody>
                    <tr>
                        <td class="tdTitilo">
                            <label for="regiao" class="form-label">Região:</label>
                        </td>
                        <td class="tdCampo">
                            <select (change)="onSelecionar(mySelectFiltroRegiao.value)" #mySelectFiltroRegiao
                                name="select" aria-placeholder="Regiao" class="form-select">
                                <option value="">Todos</option>
                                <option *ngFor="let objeto of listaRegiao" value={{objeto.id}}>{{objeto.descricao}}
                                </option>

                            </select>
                        </td>
                        <td class="tdTitilo">
                            <label for="posto" class="form-label">Posto:</label>
                        </td>
                        <td class="tdCampo">
                            <app-multiple-selection-select-all [lista]="listaPostos" [width]="larguraTela/2.5"
                                [regiaoSelecionada]="RegiaoSelecionada"
                                (infoClicada)="processarInfo($event)"></app-multiple-selection-select-all>
                        </td>
                        <td class="tdTitilo">
                            <button class="btn btn-primary" (click)="filtrarPesquisa()" id="class-button"
                                type="submit">Pesquisar</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </ol>
    </nav>
</section>
<section translate="no">
    <section style="height: auto;">
        <nav>
            <ol class="cd-breadcrumb custom-separator">
                <table>
                    <tbody>
                        <tr>
                            <td class="nomeTela">
                                Relatório de Atendentes
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ol>
        </nav>
    </section>
    @if (SemDados == true) {
    <h4 style="display: flex;justify-content: center;align-items: center;text-align: center;color: #5a5a5a;">Não exite
        dados para serem mostrados
    </h4>
    }
    @if(feitaPesquisa)
    {
    <h4 style="display: flex;justify-content: center;align-items: center;text-align: center;color: #5a5a5a;">Escolha um
        posto para visualizar o relatório
    </h4>
    }
    @if(!feitaPesquisa && !SemDados)
    {
    <div style="display: flex; justify-content: end;">
        <button type="button" (click)="exportToPDF()" class="btn btn-secondary" style="margin-right: 10px;">
            Exportar PDF<i class="fas fa-file-pdf fa-2xl" style="margin-left: 10px;"></i>
        </button>
        <button (click)="exportarParaExcel()" type="button" class="btn btn-secondary" style="margin-right: 10px;">
            Exportar Excel
            <i class="fas fa-file-excel fa-2xl" style="margin-left: 10px;"></i>
        </button>
    </div>
    <div class="style-tabela">
        <table border="0" cellpadding="0" id="tableDados" cellspacing="0" width="75%"
            style="margin-left: 6%;margin-top: 1%;">
            <thead>
                <tr>
                    <th class="cabecalho">Posto</th>
                    <th class="cabecalho">Ponto de Atendimento</th>
                    <th class="cabecalho">Atendente</th>
                    <th class="cabecalho">Abertura do ponto</th>
                    <th class="cabecalho">Hora de abertura</th>
                    <th class="cabecalho">Fechamento do Ponto</th>
                    <th class="cabecalho">Hora fechado</th>
                </tr>
            </thead>
            <tbody>
                @for (item of data; track item) {
                @for (itemPonto of item.pontosAtendimentos; track itemPonto) {
                @for (itemAtendimento of itemPonto.atendimentos; let i = $index; track itemAtendimento) {
                <tr>
                    <!-- Posto sempre repetido -->
                    @if (i === 0) {
                    <td [attr.rowspan]="itemPonto.atendimentos.length">{{ item.descricao }}</td>
                    }
                    <!-- Ponto Atendimento com rowspan só na primeira linha -->
                    @if (i === 0) {
                    <td [attr.rowspan]="itemPonto.atendimentos.length">{{ itemPonto.descricao }}</td>
                    }
                    <td>{{ itemAtendimento.nomeAtendente }}</td>
                    <td>{{ itemAtendimento.abertura | date: 'dd/MM/yyyy' }}</td>
                    <td>{{ itemAtendimento.abertura | date: 'HH:mm:ss' }}</td>
                    <td>{{ itemAtendimento.fechamento | date: 'dd/MM/yyyy' }}</td>
                    <td>{{ itemAtendimento.fechamento | date: 'HH:mm:ss' }}</td>

                </tr>
                }
                }
                }
            </tbody>
        </table>
    </div>
    }
